import * as React from "react";
import { MobXProviderContext, observer } from "mobx-react";
import { useHistory } from "react-router-dom";
import { Box, Grid } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import * as styles from "../styles.scss";
import axios from "axios";
import { CourseCard, MUIPreloader } from "../../";
import InfiniteScroll from "react-infinite-scroller";
import { HTML2React } from "../../../../../utils";
import { ICourse, ICoursesGroup } from "../../../Filestorage/types";
import { themeVariables } from "../../_Theme";
import { FSCourseGroup as CourseGroupEntity } from "../../../Filestorage/CoursesList/store";

interface IProps {
  // groupId: number;
  group: ICoursesGroup;
  getMoreCourses: () => void;
  module: string;
  href: string;
  target?: string;
  onCourseClick?: any;
  groupCardWide?: boolean;
  isWidget?: boolean;
  extended?: boolean;
  loadingNext?: boolean;
  loading?: boolean;
}

export const CoursesGroup: React.FC<IProps> = observer(({
  group,
  module,
  href,
  target,
  isWidget,
  loading,
  loadingNext,
  groupCardWide,
  getMoreCourses,
  onCourseClick,
  extended = true,
}) => {
  const theme = useTheme();

  if (!group.courses) return null;

  return !group.courses.length && group.hasMoreCourses ? (
    <MUIPreloader />
  ) : (
    <Box overflow="hidden">
      <InfiniteScroll
        // pageStart={page()}
        useWindow={false}
        loadMore={() => getMoreCourses()}
        hasMore={group.hasMoreCourses}
        style={{ flex: "1" }}
      >
        <Box className={styles.groupContainerWrap}>
          <Grid container>
            {group.courses.map((course: ICourse) => (
              <Box
                key={`course${course.id}`}
                className={
                  (isWidget || !groupCardWide)
                    ? styles.groupItemWide
                    : styles.groupItemNarrow
                }
                borderRight={themeVariables.border}
                borderBottom={themeVariables.border}
                clone
              >
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={(isWidget || !groupCardWide) ? 4 : 6}
                >
                  <Box
                    p={2}
                    bgcolor={theme.palette.grey.A100}
                    color={theme.palette.primary.dark}
                    fontWeight={600}
                    onClick={() =>
                      href
                        ? Object.assign(document.createElement("a"), {
                            target: target,
                            href: href + course.id + "/all",
                          }).click()
                        : onCourseClick(course)
                    }
                    className="react-hideBgOnHover"
                  >
                    <CourseCard course={course} />
                  </Box>
                </Grid>
              </Box>
            ))}
          </Grid>
        </Box>
        {loading || loadingNext && <MUIPreloader key="filestorage-courseslist-preloader" />}
      </InfiniteScroll>
    </Box>
  );
});
